/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface SubscriptionPlanDetailsUiModuleBody
 */
export interface SubscriptionPlanDetailsUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    moduleType: SubscriptionPlanDetailsUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    priceTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    price: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    deviceLimitTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    deviceLimit: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    adsDisclaimerTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    adsDisclaimer: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    contentDisclaimerTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    contentDisclaimer: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    downloadDisclaimerTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    downloadDisclaimer: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    valuePropositionTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    valueProposition: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    legalDisclosure: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    planTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    planSubtitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    sportsDisclaimerTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanDetailsUiModuleBody
     */
    sportsDisclaimer: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SubscriptionPlanDetailsUiModuleBodyModuleTypeEnum {
    SUBSCRIPTION_PLAN_DETAILS = 'SUBSCRIPTION_PLAN_DETAILS'
}



